export default (that, status) => {
  switch (status) {
    case "unconfirmed":
      return [that.$t("reject_order"), that.$t("confirm_order")];
    default:
      return ["", ""];
  }
};
